/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

type SearchFileIconProps = IconType & {
  variant?: 'default' | 'permits';
};

export const SearchFileIcon: FC<SearchFileIconProps> = (props) => {
  const { width, height, color, variant = 'default' } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  if (variant === 'permits') {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.66699 1.71436V5.14293L13.0956 5.14293L9.66699 1.71436Z"
          fill={color}
        />
        <path
          d="M5.09521 5.14307L7.38093 5.14307"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M5.09521 8H7.95236"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M5.09521 10.8569H7.38093"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M14.2384 13.7145L12.5933 12.0693"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M11.3813 12.5716C12.3281 12.5716 13.0956 11.8041 13.0956 10.8574C13.0956 9.91058 12.3281 9.14307 11.3813 9.14307C10.4345 9.14307 9.66699 9.91058 9.66699 10.8574C9.66699 11.8041 10.4345 12.5716 11.3813 12.5716Z"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M9.66699 1.71436V5.14293L13.0956 5.14293"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
        />
        <path
          d="M13.0953 6.85721L13.0953 5.14293L9.66671 1.71436L2.80957 1.71436L2.80957 14.2858L8.52386 14.2858"
          stroke={color}
          strokeWidth={1.37143}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7143 3.07141L13.7143 8.21427H18.8572L13.7143 3.07141Z"
        fill={color}
      />
      <path
        d="M6.85712 8.21423H10.2857"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M6.85712 12.5L11.1428 12.5"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M6.85712 16.7858H10.2857"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M20.5714 21.0715L18.1037 18.6038"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M16.2857 19.3571C17.7059 19.3571 18.8572 18.2058 18.8572 16.7857C18.8572 15.3655 17.7059 14.2142 16.2857 14.2142C14.8656 14.2142 13.7143 15.3655 13.7143 16.7857C13.7143 18.2058 14.8656 19.3571 16.2857 19.3571Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M13.7143 3.07141L13.7143 8.21427H18.8572"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
      />
      <path
        d="M18.8572 10.7857V8.21427L13.7143 3.07141L3.42859 3.07141L3.42859 21.9286L12 21.9286"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
